package io.eqoty.shared.datalayer.functions

import io.eqoty.shared.datalayer.Repository
import kotlinx.browser.window

actual suspend fun Repository.getInjectedKeplrProviderAvailable(): Boolean = withRepoContext {
    return@withRepoContext window.asDynamic().keplr != null
}